import React from "react";
import { Navigate } from "react-router-dom";

function UserPortalGuard({ children }) {
  const token = localStorage.getItem("token");
  const userData = localStorage.getItem("user");

  if (!token || !userData) {
    return <Navigate to="/loginpage" replace />;
  }

  return children;
}

export default UserPortalGuard;
